// @flow

import React, { type Node } from 'react';
import { useUniqueId } from '@tectonics/hooks';
import { getImplementedTraits } from '@tectonics/look-and-feel';
import { useFieldMetadata } from '@tectonics/prs/form';
import { useCurrentAllFeatures } from '@tectonics/prs/payment-spec';
import { useUserInputAsRadioButton } from '@tectonics/prs/user-input-values';
import { getBrandSource } from './ewallet/brands';
import { ErrorMessage, Margin, Padding, RadioButton } from '../../../atoms';
import lookAndFeel from '../../../index';

export function FieldEwalletSelect(): Node {
  const id = useUniqueId();
  const allFeatures = useCurrentAllFeatures();
  const ewalletsCodes = getImplementedTraits(lookAndFeel, 'display_ewallet_accepts_brand',  allFeatures);

  const { formHasBeenSent, submitting, validationError } = useFieldMetadata('selectedEWallet');
  const [selectedEWallet, onSelectEWallet] = useUserInputAsRadioButton('selectedEWallet');

  return (
    <Margin top={2} style={{ width: '100%' }} noFirst data-test-name="payment-type-code">
      <Padding x={1}>
        <strong>Selecione sua carteira digital abaixo:</strong>

        {ewalletsCodes.map((ewalletCode) => (
          <label key={ewalletCode} style={labelStyle} htmlFor={`${id}-${ewalletCode}`}>
            <RadioButton
              name="payment_type_code"
              data-test-value={ewalletCode}
              value={ewalletCode}
              id={`${id}-${ewalletCode}`}
              disabled={submitting}
              checked={ewalletCode == selectedEWallet}
              onChange={onSelectEWallet}
            />
            <img src={getBrandSource(ewalletCode)} alt={ewalletCode} style={{ maxWidth: '38px', margin: '0 10px' }} />
            {getEwalletLabelText(ewalletCode)}
          </label>
        ))}

        {formHasBeenSent && validationError && (
          <ErrorMessage>Por favor, selecione sua carteira digital</ErrorMessage>
        )}
      </Padding>
    </Margin>
  );
}

const labelStyle = {
  width: '100%',
  display: 'flex',
  alignItems: 'center',
  marginTop: '12px',
  cursor: 'pointer',
};

function getEwalletLabelText(ewalletCode: string): Node {
  switch (ewalletCode) {
    case 'ame':
      return 'Ame';
    case 'mercadopago':
      return 'Mercado Pago';
    case 'paypal':
      return 'PayPal';
    case 'picpay':
      return 'PicPay';
    default:
      throw new Error(`Ewallet "${ewalletCode}" not supported`);
  }
}
